const ENDPOINTS = {
  all: (params = '') => `payments-settings/?${params}`,
};

export {ENDPOINTS};
